/**
 * Decode a Google "encoded polyline algorithm format" string into lat/lng
 * points. We don't load the Maps `geometry` library (so
 * `google.maps.geometry.encoding.decodePath` isn't available), and this is a
 * tiny pure function — mirrors the backend decoder used for off-route geometry.
 */
export function decodePolyline(encoded: string): Array<{ lat: number; lng: number }> {
  const path: Array<{ lat: number; lng: number }> = [];
  let index = 0;
  let lat = 0;
  let lng = 0;

  while (index < encoded.length) {
    let result = 0;
    let shift = 0;
    let byte: number;
    do {
      byte = encoded.charCodeAt(index++) - 63;
      result |= (byte & 0x1f) << shift;
      shift += 5;
    } while (byte >= 0x20);
    lat += result & 1 ? ~(result >> 1) : result >> 1;

    result = 0;
    shift = 0;
    do {
      byte = encoded.charCodeAt(index++) - 63;
      result |= (byte & 0x1f) << shift;
      shift += 5;
    } while (byte >= 0x20);
    lng += result & 1 ? ~(result >> 1) : result >> 1;

    path.push({ lat: lat * 1e-5, lng: lng * 1e-5 });
  }
  return path;
}
